const HOME_SUB_MENU =
  [
    {
      key: 'home/myoverview',
      icon: 'HomeOutlined',
      label: "Home"
    },
    {
      key: 'home/approvals/tms/dashboard',
      icon: 'TickOutlined',
      label: "Approvals"
    },
    {
      key: 'home/timesheet/draft',
      icon: 'TimeSheetFilled',
      label: "Time Sheet"
    },
    {
      key: 'home/leaves',
      icon:'CalendarOutlined',
      label: "Leaves"
    }
    // {
    //   key: 'home/performance',
    //   icon:'PerformanceFilled',
    //   label: "Performance"
    // },
    // {
    //   key: 'home/expenses',
    //   icon:'PayslipOutlined',
    //   label: "Expenses"
    // },
    // {
    //   key: 'home/payslips',
    //   icon:'PayslipOutlined',
    //   label: "Pay slips"
    // },
    // {
    //   key: 'home/managetax',
    //   icon:'ManageTaxOutlined',
    //   label: "Manage Tax"
    // }
  ];


const FILES_SUB_MENU = [{
  label: 'My Drive',
  key: 'dms/mydrive',
  icon: 'DocumentsOutlined'
},
{
  label: 'Recent',
  key: 'dms/recent',
  icon: 'LogOutlined'
},
{
  label: 'Starred',
  key: 'dms/starred',
  icon: 'StarOutlined'
},
{
  label: 'Shared',
  key: 'dms/shared',
  icon: 'SharedOutlined'
},{
  label: 'Bin',
  key: 'dms/bin',
  icon: 'DeleteOutlined'
}];

const APICLIENT_SUB_MENU = [{
  label: 'Dashboard',
  key: 'apiclient/dashboard',
  icon: 'DashboardFilled'
},
//  {
//   label: 'Environments',
//   key: 'apiclient/environment',
//   icon: 'EnvironmentOutlined'
// },
{
  label: 'Collections',
  key: 'apiclient/collections',
  icon: 'APIOutlined'
}];
// ,
// {
//   label: 'CI/CD',
//   key: 'apiclient/cicd',
//   icon: 'DeploymentOutlined'
// }];



const NAVIGATIONS = [{
  label: 'Task Planner',
  id: 'taskplanner'
}, {
  label: 'Files',
  id: 'files'

}, {
  label: 'API Client',
  id: 'apiclient'
}, {
  label: 'Invoices',
  id: 'invoices'
}, {
  label: 'Organization',
  id: 'org'
}, {
  label: 'Admin Console',
  id: 'settings'
}
];

const CALENDAR_SUB_MENU = [
  {
    label: 'Calendar',
    key: 'engagements/meetings',
    icon: 'CalendarOutlined'
  },
  {
    label: 'Events',
    key: 'engagements/events',
    icon: 'MeetingsOutlined'
  }];

const CUSTOMERS_SUB_MENU = [
  {
    label: 'Dashboard',
    key: 'customers/dashboard',
    icon: 'DashboardOutlined'
  },
  {
    label: 'Leads',
    key: 'customers/leads',
    icon: 'SalesOutlined'
  },
  {
    label: 'Clients',
    key: 'customers/details',
    icon: 'ClientsOutlined'
  },
  // {
  //   label: 'Announcements',
  //   key: 'customers/announcements',
  //   icon: 'AnnouncementsOutlined'
  // },
  {
    label: 'Notification Templates',
    key: 'customers/templates',
    icon: 'NotificationOutlined'
  },
  {
    label: 'Workflow',
    key: 'customers/workflow',
    icon: 'WorkflowOutlined'
  },
  {
    label: 'Account Types',
    key: 'customers/activity',
    icon: 'TimeLineOutlined'
  },
  {
    label: 'Ratings',
    key: 'customers/ratings',
    icon: 'StarOutlined'
  },
  {
    label: 'Payments',
    key: 'customers/payments',
    icon: 'InvoiceOutlined'
  }
];
const TOPNAV = [
  {
    key: 'workspace',
    link: 'workspace',
    icon: 'WorkspaceOutlined',
    text: 'Workspace',
    active: true
  },
  {
    key: 'files',
    link: `/files/dashboard`,
    icon: 'DocumentsOutlined',
    text: 'Files',
    active: false,
    condition: 'workspace'
  },
  {
    key: 'apiclient',
    link: `/apiclient/environments`,
    icon: 'EnvOutlined',
    text: 'API Client',
    active: false,
    condition: 'workspace'
  },
  {
    key: 'invoices',
    link: `/invoices/dashboard`,
    icon: 'InvoicesOutlined',
    text: 'Invoices',
    condition: 'workspace',
    active: true
  },
  {
    key: 'calendar',
    link: '/calendar/dashboard',
    icon: 'CalendarOutlined',
    text: 'Calendar',
    active: true
  },
  {
    key: 'org',
    link: '/org/employees',
    icon: 'OrgOutlined',
    text: 'Organization',
    active: true
  },
  {
    key: 'admin',
    link: '/admin/settings',
    icon: 'SettingsOutlined',
    text: 'Admin Console',
    active: true
  }
];

export {
  NAVIGATIONS,
  HOME_SUB_MENU,
  FILES_SUB_MENU,
  APICLIENT_SUB_MENU,
  CALENDAR_SUB_MENU,
  CUSTOMERS_SUB_MENU,
  TOPNAV
};